import { Component, OnInit } from '@angular/core';
import { ClassToggleService } from '@coreui/angular';
import { ApiService } from '../../../api/api.service';
import { Result } from '../../../shared/interfaces';

@Component({
    selector: 'app-footer',
    templateUrl: './public-footer.component.html',
    styleUrl: './public-footer.component.scss'
})
export class PublicFooterComponent implements OnInit {

    private _config: any;
    currentYear: number = new Date().getFullYear(); // <-- Año actual

    constructor(
        private  readonly classToggler: ClassToggleService, 
        private readonly api: ApiService) {

    }

    ngOnInit(): void {
        this.obtenerConfiguracion()
    }

    async obtenerConfiguracion() {
        try {
            const path = 'configuracion/actual';
            const result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result;
            this._config = result.data;
        } catch (e) {

        }
    }

    get config(): any {
        return this._config;
    }
}